import { FrontendContextV1 } from "@made-people/nestjs-bff-service";
import { getKlarnaPaymentMethodCode } from "../utils/get-klarna-payment-method-code";
import { useFeatureValue } from "@growthbook/growthbook-react";

export const usePaymentMethodCode = (frontendContext: FrontendContextV1) => {
  const paymentMethodFlag = useFeatureValue("payment-method", "klarna");

  const paymentMethodCode =
    paymentMethodFlag === "klarna"
      ? getKlarnaPaymentMethodCode(frontendContext.country)
      : paymentMethodFlag;

  return paymentMethodCode;
};
